import React from 'react'

const HY = (props) => {
    return (
        <svg {...props} width={props.width ? props.width : '24'} height={props.height ? props.height : '24'} xmlns="http://www.w3.org/2000/svg" id="flag-icons-am" viewBox="0 0 640 480">
            <path fill="#d90012" d="M0 0h640v160H0z"/>
            <path fill="#0033a0" d="M0 160h640v160H0z"/>
            <path fill="#f2a800" d="M0 320h640v160H0z"/>
        </svg>
    )
}

export default HY;


// WEBPACK FOOTER //
// ./src/assets/flags/HY.jsx